import { grey } from "@mui/material/colors";

const styles = {
  primaryButton: {
    backgroundColor: "yellow.main",
    width: "max-content",
    px: 2,
    color: "black",
    "&:hover": {
      backgroundColor: "yellow.main",
    },
    textTransform: "none",
    fontSize: 16,
  },
  secondaryButton: {
    color: "secondary.main",
    textTransform: "none",
  },
  closeButton: {
    color: grey[500],
    fontSize: 14,
    position: "absolute",
    right: 10,
    top: 10,
  },
};

export default styles;
